export const STORE_LINKS = {
  googlePlay: "https://play.google.com/store/search?q=K%20PLAZA&c=apps",
  appStore: "https://apps.apple.com/tr/search?term=K%20PLAZA",
};

export const CONTACT = {
  whatsapp: "0505 011 44 04",
  whatsappLink: "https://wa.me/905050114404",
};

export const FEATURES = [
  {
    icon: "qr",
    title: "QR İndirim Sistemi",
    desc: "Bireysel kullanıcının QR kodunu okutan işletme indirim uygular",
  },
  {
    icon: "images",
    title: "Proje Galerisi",
    desc: "Devam eden ve tamamlanan projelerinizi görsel + video ile paylaşın",
  },
  {
    icon: "map",
    title: "Harita Entegrasyonu",
    desc: "Kullanıcılar sizi haritada bulur, adresinize tek dokunuşta yol tarifi alır",
  },
  {
    icon: "users",
    title: "Takipçi Sistemi",
    desc: "Bireysel kullanıcılar işletmenizi takip eder, yeni projelerden haberdar olur",
  },
  {
    icon: "bell",
    title: "Anlık Bildirimler",
    desc: "Kampanyalar, duyurular ve önemli haberleri direkt telefonlara ulaştırın",
  },
  {
    icon: "chart",
    title: "Admin Dashboard",
    desc: "Kullanıcılar, işletmeler, eşleşmeler ve bildirimlerin tam kontrolü",
  },
  {
    icon: "chat",
    title: "7/24 Canlı Destek",
    desc: "WhatsApp üzerinden anında müşteri desteği tek tık uzağınızda",
  },
  {
    icon: "card",
    title: "Abonelik Sayacı",
    desc: "Paket bitiş sürenizi anlık gösteren sayaç, yenileme uyarıları",
  },
];

export const PREVIEWS = [
  {
    emoji: "🏠",
    title: "Ana Sayfa Akışı",
    desc: "Instagram tarzı proje akışı - devam eden veya tamamlanan projeler durumlarıyla",
  },
  {
    emoji: "🗺️",
    title: "Harita",
    desc: "Balıkesir'deki tüm işletmeler haritada, sektörlere göre filtrele",
  },
  {
    emoji: "👤",
    title: "Profil & QR",
    desc: "Kişisel QR kodunuz her zaman elinizin altında",
  },
];

export const PACKAGE_FEATURES = [
  "Bireysel ve işletme hesapları için geçerli",
  "K-Plaza QR kod ile standart indirim",
  "İşletme profili, galeri ve harita listeleme",
  "Anlık bildirimler ve takipçi sistemi",
  "7/24 WhatsApp canlı destek",
];

export const PACKAGES = [
  { id: "1ay", name: "1 Aylık Üyelik", label: "1 Ay", months: 1, price: 999, popular: false, features: PACKAGE_FEATURES },
  { id: "3ay", name: "3 Aylık Üyelik", label: "3 Ay", months: 3, price: 2697, popular: false, features: PACKAGE_FEATURES },
  { id: "6ay", name: "6 Aylık Üyelik", label: "6 Ay", months: 6, price: 5394, popular: false, features: PACKAGE_FEATURES },
  { id: "12ay", name: "1 Yıllık Üyelik", label: "1 Yıl", months: 12, price: 10788, popular: true, features: PACKAGE_FEATURES },
];

export const formatTL = (n) => n.toLocaleString("tr-TR");

export const SECTORS = [
  "Tekstil",
  "Bilişim",
  "İnşaat",
  "Endüstri",
  "Gıda",
  "Sağlık",
  "Eğitim",
  "Otomotiv",
  "Mobilya",
  "Turizm",
  "Hizmet",
  "Diğer",
];

export const LEGAL = {
  sozlesme: {
    title: "Mesafeli Satış Sözleşmesi",
    body: `MESAFELİ SATIŞ SÖZLEŞMESİ

MADDE 1 – TARAFLAR VE SÖZLEŞME ÖNCESİ SIFAT BEYANI

1.1. SATICI:
• Unvanı: K PLAZA Anonim Şirketi ("SATICI")
• Platform: BETA İş Platformu
• Adres: Paşaalanı Mah. Çevre Yolu Cad. No: 45/A Karesi / Balıkesir
• Mersis No: 012345678900001
• Telefon / Müşteri Destek: 0507 357 19 89
• E-posta: info@kplaza.com.tr
• KEP Adresi: kplaza@hs01.kep.tr

1.2. ALICI: Web sitesi (betaisplatformu.com) veya mobil uygulama üzerinden dijital üyelik/paket siparişi oluşturan, fatura ve iletişim bilgileri sipariş ekranında girilen gerçek veya tüzel kişidir ("ALICI").

1.3. Taraf Sıfatı ve Hukuki Rejim Ayrımı:
• 1.3.1. Tüketici İşlemi: ALICI'nın münhasıran ticari veya mesleki olmayan amaçlarla "Bireysel Üyelik" satın alması halinde, ALICI 6502 sayılı Kanun ve Mesafeli Sözleşmeler Yönetmeliği kapsamında "Tüketici" sıfatını haizdir.
• 1.3.2. Ticari İş / Bayi Statüsü: ALICI'nın "Temel", "Standart" veya "Premium" Bayi Paketi satın alması ya da fatura bilgisi olarak şirket/şahıs firması veya vergi numarası beyan etmesi halinde; işbu Sözleşme'yi ticari ve mesleki faaliyetleri kapsamında akdettiğini, tacir veya esnaf sıfatını haiz olduğunu, 6502 sayılı Kanun'un tüketiciyi koruyucu hükümlerinden yararlanamayacağını, işlem hakkında 6102 sayılı TTK ve 6098 sayılı TBK hükümlerinin uygulanacağını kabul eder.

MADDE 2 – KONU VE KAPSAM
İşbu Sözleşme'nin konusu; ALICI'nın SATICI'ya ait platform üzerinden elektronik ortamda siparişini tesis ettiği, nitelikleri ve satış bedeli web sitesinde açıkça belirtilen dijital hizmet üyelik paketlerinin (Bireysel Üyelik ile Temel, Standart ve Premium Bayi Paketleri) satışı, dijital ifası, tarafların karşılıklı hak ve yükümlülüklerinin belirlenmesidir.

MADDE 3 – HİZMETİN NİTELİĞİ, İFA BAŞLANGICI VE LOG KAYITLARI
3.1. Dijital İfa Niteliği: Sözleşme konusu ürün, fiziki teslimatı gerektirmeyen, internet ve mobil uygulama altyapısı üzerinden erişim yetkisi sağlanan gayri maddi dijital hizmettir.
3.2. Hizmetin İfasının Başlangıç Anı: Hizmetin ifası, ALICI'ya kullanıcı adı ve şifre bilgilerinin e-posta ile iletilmesiyle değil; ALICI'nın platforma ilk başarılı kullanıcı girişini (login) gerçekleştirmesi veya dijital içeriklere fiilen erişim sağlaması anında başlar.
3.3. Delil ve Log Kayıtları: ALICI'nın platforma giriş anı, IP adresi, cihaz bilgisi, oturum süresi ve işlemleri sunucu log kayıtları ve zaman damgasıyla kayıt altına alınır. Taraflar, bu kayıtların HMK 193. madde anlamında bağlayıcı ve münhasır delil teşkil edeceğini kabul eder.

MADDE 4 – BEDEL, ÖDEME VE OTOMATİK YENİLENMEME GÜVENCESİ
4.1. Tahsilat: Üyelik bedelleri, 6493 sayılı Kanun uyarınca lisanslı ödeme kuruluşu iyzico altyapısı üzerinden kredi/banka kartı ile tahsil edilir. Kredi kartı verileri SATICI tarafından tutulmaz.
4.2. Fiyat Şeffaflığı: İlan edilen paket bedellerine KDV dahildir. Paketler aylık (30 gün) veya yıllık (365 gün) süreyle sunulur.
4.3. Otomatik Yenilenmeme: Sürenin hitamında ALICI'nın kartından otomatik çekim yapılmaz; abonelik kendiliğinden yenilenmez. SATICI, paket bitimine 7 gün kala bilgilendirme e-postası gönderir.

MADDE 5 – CAYMA HAKKI, KULLANIM USULÜ VE İSTİSNALARI
5.1. Tüketici ALICI'lar Yönünden:
• 5.1.1. Genel Kural: Tüketici ALICI, Sözleşme'nin kurulduğu tarihten itibaren 14 gün içinde gerekçe göstermeksizin ve cezai şart ödemeksizin cayma hakkına sahiptir.
• 5.1.2. İstisna (Yön. m.15/1-ğ): Elektronik ortamda anında ifa edilen hizmetlerde; ALICI'nın ifaya onay kutusunu işaretleyerek ve platforma ilk girişi yaparak hizmeti tüketmeye başlaması halinde cayma hakkı sona erer.
• 5.1.3. Bedel İadesi: Geçerli cayma bildiriminin ulaştığı tarihten itibaren en geç 14 gün içinde tahsil edilen tüm bedel, kesinti yapılmaksızın iade edilir.
5.2. Tacir / Bayi ALICI'lar Yönünden: Ticari/mesleki amaçla hareket eden Bayi ALICI'lar tüketici cayma hakkına sahip değildir; talepleri TTK ve TBK genel hükümlerine tabidir.

MADDE 6 – FESİH, CEZAİ ŞART VE SORUMLULUK SINIRI
6.1. Tacir ALICI'nın haklı sebep olmaksızın sözleşmeyi süresinden önce feshetmesi halinde, en yüksek aylık fatura tutarı kadar likit erken fesih tazminatı talep edilebilir.
6.2. SATICI, geçici erişim aksaklıkları nedeniyle doğabilecek kâr/veri/itibar kaybı gibi dolaylı zararlardan sorumlu tutulamaz; akdi sorumluluğu ilgili dönem için ödenen net paket bedeli ile sınırlıdır.

MADDE 7 – SATICININ TAAHHÜTLERİ
7.1. SATICI, pakette tanımlı dijital modülleri aktif tutmak ve hizmeti kesintisiz sunmak adına azami özeni gösterir.
7.2. Planlı bakım, omurga arızaları ve mücbir sebepler sözleşme ihlali veya ayıplı hizmet sayılmaz.

MADDE 8 – ALICININ YÜKÜMLÜLÜKLERİ VE 2FA
8.1. ALICI beyan ettiği kimlik, unvan, adres ve iletişim verilerinin doğru ve güncel olduğunu taahhüt eder.
8.2. ALICI hesap şifresini gizli tutmakla yükümlüdür; Bayi kullanıcıları için iki kademeli kimlik doğrulama (2FA) güvenlik zorunluluğudur.
8.3. ALICI hukuka, ahlaka ve fikri mülkiyet mevzuatına aykırı içerik yükleyemez; aksi halde SATICI hesabı askıya alabilir.

MADDE 9 – FATURA VE VERGİ ESASLARI
SATICI, tahsil edilen bedel karşılığında 213 sayılı VUK uyarınca e-Fatura/e-Arşiv Fatura tanzim eder ve ALICI'nın kayıtlı e-posta adresine iletir.

MADDE 10 – TACİR ALICILAR İÇİN AYIP İHBAR SÜRELERİ
Tacir ALICI, TTK 23/1-c uyarınca açık ayıpları 2 gün, gizli ayıpları 8 gün içinde KEP veya noter ile ihbar etmekle yükümlüdür.

MADDE 11 – UYUŞMAZLIKLARIN ÇÖZÜMÜ
11.1. Tüketici uyuşmazlıklarında ALICI'nın yerleşim yerindeki Tüketici Hakem Heyetleri/Tüketici Mahkemeleri yetkilidir.
11.2. Ticari uyuşmazlıklarda Balıkesir Asliye Ticaret Mahkemeleri ve İcra Daireleri münhasıran yetkilidir.

MADDE 12 – TEBLİGAT VE ŞEKİL ŞARTI
Fesih, temerrüt veya cayma bildirimleri noter, taahhütlü mektup veya KEP üzerinden yapılır. Rutin operasyonel bildirimler sistem e-posta adresine iletilir.

MADDE 13 – YÜRÜRLÜK VE KURULUM
İşbu Sözleşme, ALICI'nın onay kutusunu işaretlemesi ve ödeme işleminin başarıyla tamamlanması anında elektronik ortamda kurulmuş ve yürürlüğe girmiştir.`,
  },
  kvkk: {
    title: "Gizlilik Politikası (KVKK)",
    body: `KİŞİSEL VERİLERİN KORUNMASI AYDINLATMA METNİ VE GİZLİLİK POLİTİKASI

1. VERİ SORUMLUSUNUN KİMLİĞİ
6698 sayılı KVKK m.10 uyarınca veri sorumlusu sıfatıyla hareket eden K PLAZA Anonim Şirketi (Mersis No: 012345678900001) olarak kişisel verilerinizi hukuka, dürüstlük kuralına ve ölçülülük ilkelerine uygun şekilde işlemekteyiz.

2. KİŞİSEL VERİ KATEGORİLERİ VE İŞLEME AMAÇLARI
• Kimlik Verisi (ad, soyad, T.C./vergi no): Üyelik kaydı, kimlik tespiti, fatura tanzimi — KVKK m.5/2-c ve m.5/2-ç.
• İletişim Verisi (e-posta, telefon, fatura adresi, il/ilçe): Hesap aktivasyon bilgilerinin iletilmesi, tebligatlar, müşteri desteği — KVKK m.5/2-c.
• İşlem ve Finans Güvenliği (sipariş no, ödeme tutarı, iyzico referansı): Muhasebe kayıtları, mali denetim (kart verileri tutulmaz) — KVKK m.5/2-ç.
• İşlem Güvenliği ve Loglar (IP, giriş-çıkış logları, zaman damgası): 5651 sayılı Kanun yükümlülüğü, platform güvenliği — KVKK m.5/2-a, ç ve f.
• Bayi/Kurumsal Veri (işletme unvanı, yetkili, faaliyet alanı): Bayi modülünün tahsisi — KVKK m.5/2-c.

3. VERİ SAKLAMA SÜRELERİ
• Muhasebe/finansal kayıtlar: VUK m.253 ve TTK m.82 uyarınca 10 yıl.
• Sözleşme ve işlem güvenliği logları: 10 yıl.
• Trafik verileri (loglar): 5651 sayılı Kanun kapsamında 2 yıl.
Sürelerin bitiminde veriler İmha Politikası doğrultusunda silinir, yok edilir veya anonim hale getirilir.

4. VERİLERİN AKTARILDIĞI TARAFLAR
• Ödeme Kuruluşu: İyzico Ödeme Hizmetleri A.Ş. (KVKK m.5/2-c).
• Yetkili Kamu Mercileri: Mahkemeler, icra daireleri, GİB ve KVKK Kurumu'nun bağlayıcı talepleri doğrultusunda (KVKK m.5/2-ç).
• Altyapı/Sunucu Sağlayıcıları: Veri merkezleri Türkiye'de bulunan yurt içi güvenli bulut sağlayıcıları (KVKK m.5/2-f).
• Yurt Dışına Aktarım: KVKK m.9'a aykırı olarak, Kurul izni veya açık rıza olmaksızın yurt dışına aktarılmaz.

5. ÇEREZ YÖNETİMİ
Platformda yalnızca teknik olarak zorunlu oturum çerezleri aktif kullanılır. Performans/analiz/pazarlama çerezleri "Çerez Tercih Paneli" üzerinden ALICI'nın aktif tercihi (opt-in) olmadan çalıştırılmaz.

6. TEKNİK VE İDARİ TEDBİRLER
SATICI, KVKK m.12 uyarınca; 256-bit SSL şifreleme uygular, yönetim panellerinde 2FA sağlar, erişimi yetki matrisi ile sınırlandırır ve altyapıyı sızma testleri ile korur.

7. İLGİLİ KİŞİNİN HAKLARI VE BAŞVURU
ALICI, KVKK m.11'deki haklarını (öğrenme, düzeltme, silme, itiraz ve tazminat) kullanmak üzere;
• Yazılı olarak: Paşaalanı Mah. Çevre Yolu Cad. No: 45/A Karesi / Balıkesir adresine,
• Elektronik posta ile: kplaza@hs01.kep.tr KEP adresine veya kayıtlı e-postadan kvkk@kplaza.com.tr adresine başvurabilir.
Başvurular en geç 30 gün içinde ücretsiz sonuçlandırılır. WhatsApp hattı yalnızca bilgilendirme amaçlı olup resmi başvuru kanalı değildir.`,
  },
};
